import React from "react";
import { useTranslation } from "react-i18next";

const Section5 = () => {
  const { t } = useTranslation();
  // {t("header.Services")}
  return (
    <section className="mt-8 lg:mt-44">
      <div className="mx-5 lg:mx-16 relative">
        <div
          style={{
            backgroundImage:
              "url(/assets/images/HomePage/background_secure.png)",
          }}
          className="h-[400px] sm:h-[350px] md:h-[300px] custom1200:h-[400px] w-full bg-cover bg-center text-white  "
        >
        

          <div className="absolute bg-black w-full h-full top-0 left-0 opacity-50 z-0 lg:hidden"></div>

          <div className="flex flex-col text-center items-center justify-center absolute 
          top-0 left-0 px-5 custom1200:pl-16 h-full  z-10 lg:w-1/2 lg:text-left lg:items-start lg:justify-start lg:pt-16">
            <h1 className="text-primary-green font-bold text-2xl lg:text-4xl mb-4">
              {t("HomePage.titreSecurite")}
            </h1>
            <p className="lg:pr-8">{t("HomePage.textSecurite")}</p>
          </div>

          <div className="absolute bottom-0 right-0 hidden lg:block px-5 custom1200:pr-16">
            <img
              src="/assets/images/HomePage/security doctor.png"
              alt="client"
              className="w-[500px] custom1200:w-[600px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Section5;
